export const INDUSTRIES = [
  { value: "Agriculture", label: "Agriculture" },
  { value: "Automobile", label: "Automobile" },
  { value: "Banking", label: "Banking" },
  { value: "Construction", label: "Construction" },
  { value: "Consulting Services", label: "Consulting Services" },
  { value: "Education", label: "Education" },
  { value: "Electronics", label: "Electronics" },
  { value: "Energy", label: "Energy" },
  {
    value: "Fashion, Beauty & Cosmetics",
    label: "Fashion, Beauty & Cosmetics",
  },
  {
    value: "Food Services & Restaurants",
    label: "Food Services & Restaurants",
  },
  { value: "Food and Beverage", label: "Food and Beverage" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Insurance", label: "Insurance" },
  { value: "Legal Services", label: "Legal Services" },
  { value: "Logistics", label: "Logistics" },
  { value: "Marketing & Advertising", label: "Marketing & Advertising" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Non-profit", label: "Non-profit" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Retail", label: "Retail" },
  { value: "Sports", label: "Sports" },
  { value: "Technology", label: "Technology" },
  { value: "Telecommunication", label: "Telecommunication" },
  { value: "Travel & Tourism", label: "Travel & Tourism" },
  { value: "Others", label: "Others" },
];

export const SIZES = [
  { value: "1-25", label: "1 - 25" },
  { value: "26-50", label: "26 - 50" },
  { value: "51-100", label: "51 - 100" },
  { value: "101 and Above", label: "101 and Above" },
];
